<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

		
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索任務名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加任務</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button>
				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="啟用狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="啟用" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center"></el-table-column>
                
				<el-table-column align="center" prop="sort" label="排序" width="50">
				</el-table-column>

			
				<el-table-column align="center" prop="subject_name" label="科目">
				</el-table-column>

				<el-table-column align="center"  prop="num" label="題目數量">
				</el-table-column>

                <el-table-column align="center"  prop="time" label="做題時長（秒）">
				</el-table-column>

                <el-table-column align="center" prop="send_score" label="完成獲得積分">
				</el-table-column>

                <el-table-column align="center"  prop="send_diamond" label="完成獲得鑽石">
				</el-table-column>

				<el-table-column align="center"  prop="send_coin" label="完成獲得金幣">
				</el-table-column>

				<el-table-column align="center"  prop="ok_num" label="達標分數">
				</el-table-column>
		
		
				<el-table-column align="center" prop="status" label="啟用狀態" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.status ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeStatus(scope.row)"
						plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="280"   prop="create_time" label="創建時間">
				</el-table-column>

				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改任務' : '添加任務'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'130px'">

                <el-form-item label="學科類型"   prop="subject_id">
					<el-select v-model="form.subject_id">
						<el-option
						v-for="item in subject_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="題目數量" prop="num">
					<el-input  v-model="form.num" type="number" placeholder="題目數量"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="做題時間（秒）" prop="time">
					<el-input  v-model="form.time" type="number" placeholder="做題時間（秒）"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="完成獲得積分" prop="send_score">
					<el-input  v-model="form.send_score" type="number" placeholder="完成獲得積分"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="完成獲得鑽石" prop="send_diamond">
					<el-input  v-model="form.send_diamond" type="number" placeholder="完成獲得鑽石"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="完成獲得金幣" prop="send_coin">
					<el-input  v-model="form.send_coin" type="number" placeholder="完成獲得金幣"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="達標分數" prop="ok_num">
					<el-input  v-model="form.ok_num" type="number" placeholder="達標分數"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="排序" prop="sort">
					<el-input  v-model="form.sort" type="number" placeholder="排序（正序）"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item label="啟用狀態">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>啟用</el-radio>
						<el-radio :label="0" border>禁用</el-radio>
					</el-radio-group>
				</el-form-item>

			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					status:-1,
				},
				model_title: 'Task',
				auth_val: 'Task',
				preUrl: "data/taskList", //列表地址
				delAllUrl: "data/delTaskAll", //批量删除地址
				delUrl: "data/delTask", //删除單条地址
				addUrl: "data/addTask", //添加/修改地址
				editStatusUrl:"data/editStatusTask",//修改狀態地址

				tableData: [],
				form: {
					id:0,
                    subject_id:null,
					num:0,
					time:0,
					send_score:0,
					send_diamond:0,
					send_coin:0,
					ok_num:0,
					status:1,
					sort:0,
				},
				rules: {
					num: [
                        {
                            required: true,
                            message: "題目數量不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value <= 0) {
                                    callback(new Error('題目數量不能小於或等於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
                    time: [
                        {
                            required: true,
                            message: "做題时長不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value <= 0) {
                                    callback(new Error('做題时長不能小於或等於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
                    ok_num: [
                        {
                            required: true,
                            message: "達標分數不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value <= 0) {
                                    callback(new Error('達標分數不能小於或等於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
                    send_score: [
                        {
                            required: true,
                            message: "完成獲得積分不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value <= 0) {
                                    callback(new Error('完成獲得積分不能小於或等於0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
                    send_diamond: [
                        {
                            required: true,
                            message: "完成獲得鑽石不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value < 0) {
                                    callback(new Error('完成獲得鑽石不能小于0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],
                    send_coin: [
                        {
                            required: true,
                            message: "完成获得金幣不能為空",
                            trigger: 'blur',
                        }, {
                            validator: (rule, value, callback) => {
                                if (value === '' || value < 0) {
                                    callback(new Error('完成获得金幣不能小于0'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur'
                        }
					],

				},
				prop: 'sort',
				sort: 'ascending',
				subject_list: [],
				check_img_list:[]
			}
		},
        created() {
			this.commonList(['subject_list']);
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
				//公共列表
            commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.subject_list = list.subject

                    if (this.subject_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.form.subject_id = this.subject_list[0].id;
					}

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.form.type = this.from.type
						this.addOrEdit(this.form)
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
                        subject_id:this.form.subject_id,
                        num:0,
                        time:0,
                        send_score:0,
                        send_diamond:0,
                        send_coin:0,
                        status:1,
                        sort:0,
                        ok_num:0,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						subject_id: e.row.subject_id,
						num:e.row.num,
						sort:e.row.sort,
						ok_num:e.row.ok_num,
						time: e.row.time,
						status: e.row.status,
						send_diamond: e.row.send_diamond,
						send_coin: e.row.send_coin,
						send_score: e.row.send_score,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
		
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					status:-1,
					type:"1",
					time:[],
				}
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>

<style>
</style>
